import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  if (!data || (typeof data === 'string' && data.includes('<html>'))) {
    throw {
      message: 'Plan service is temporarily unavailable. Please try again.',
      code: 'SERVER_ERROR_500',
    }
  }
  if (isStatusOK(data) && data?.data?.responseStatus?.code === '000') {
    console.log('data at try block in responseParser getBrowsePlanList', data)
    return data.data.responseObject
  } else {
    console.log('data at catch block in responseParser getBrowsePlanList', data.data)
    // throw getNetworkResponseError(data?.data)
    const errorBody = data?.data || data || { message: 'Unable to fetch plans' }
    console.log('Error encountered in getBrowsePlanList parser:', errorBody)

    // Pass a safe object to the restricted util
    throw getNetworkResponseError(errorBody)
  }
}
export const getBrowsePlanListBCApi = (tokens: any, body: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers['x-jfsUserId'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || '1972283249505670348'
  config.headers['x-mobileNumber'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || 'N/A'
  config.headers['x-channelId'] = RootStore.agent.session.CHANNEL_ID || '3155'
  config.headers['x-channel-user-id'] =
    RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || '1123766817865366323'
  config.headers['x-intercept-gateway'] = 'SERVICE/JPB'
  const requestBody = {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: RootStore.agent.session.CHANNEL_ID || '',
      channelId: RootStore.agent.session.CHANNEL_ID || '',
      returnUrl: null,
      callbackUrl: null,
    },
    product: {
      id: String(body.billerMasterId) || '',
      categoryId: String(body.categoryId) || '',
    },
    circleDetails: {
      id: String(body.circleMasterId) || '',
    },
    customerDetails: {
      prepaidMobile: {
        number: body.mobileNumber || '',
      },
    },
  }
  const request: Request<{}> = {
    apiPath: APIEndPoints.getBrowsePlanList,
    method: 'POST',
    config: config,
    body: requestBody,
  }

  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })

  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Data received from getBrowsePlanListBCApi')
      console.log('requestBody in getBrowsePlanListBCApi', requestBody)
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
